import React, { useMemo } from 'react';
import { FIXED_LAYOUTS, PLAIN_LAYOUTS } from '../../../../utils/video-layout';

interface Props {
	previewLayout: string;
}

export default function FixedLayoutMsg(props: Props) {
	const { previewLayout } = props;

	const [isPlain, isFixed] = useMemo((): [boolean, boolean] => {
		const plain = PLAIN_LAYOUTS.some((l) => l === previewLayout);
		const fixed = FIXED_LAYOUTS.some((l) => l === previewLayout);

		return [plain, fixed];
	}, [previewLayout]);

	if (isPlain) {
		return (
			<div className="settings-container spacing-container">
				<div className="align-items-center justify-content-space-between">
					<label className="fixed-spacing-label">
						<span>No Settings Available for the Selected Layout</span>
					</label>
				</div>
			</div>
		);
	}

	if (isFixed) {
		return (
			<div className="settings-container spacing-container">
				<div className="align-items-center justify-content-space-between">
					<label className="fixed-spacing-label">
						<span>Fixed spacing layout selected</span>
					</label>
				</div>
			</div>
		);
	}

	return null;
}